"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Registration = void 0;
var Destroyable_1 = require("./Destroyable");
var TeardownLogic_1 = require("./TeardownLogic");
/**
 * This object will be returned by register functions to unregister things
 */
var Registration = /** @class */ (function (_super) {
    __extends(Registration, _super);
    function Registration(teardownLogic) {
        var _this = _super.call(this) || this;
        _this.teardownLogic = teardownLogic;
        return _this;
    }
    /**
     *
     * TODO: Use in all places where manually setting up  pair things
     */
    Registration.create = function (creator) {
        var _this = this;
        var isDestroyed = false;
        var teardownLogic = creator({ isDestroyed: function () { return isDestroyed; } });
        return new Registration(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        isDestroyed = true;
                        _a = TeardownLogic_1.teardown;
                        return [4 /*yield*/, teardownLogic];
                    case 1: return [4 /*yield*/, _a.apply(void 0, [_b.sent()])];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * Join multiple registrations into one
     *
     * @param registrations
     * @returns one registration that will be destroyed when this one is destroyed
     */
    Registration.join = function () {
        var _this = this;
        var registrations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            registrations[_i] = arguments[_i];
        }
        return new Registration(function () {
            return Promise.all(registrations.map(function (registrationPromise) { return __awaiter(_this, void 0, void 0, function () {
                var registration;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, registrationPromise];
                        case 1:
                            registration = _a.sent();
                            if (!registration) return [3 /*break*/, 3];
                            return [4 /*yield*/, registration.destroy()];
                        case 2: return [2 /*return*/, _a.sent()];
                        case 3: return [2 /*return*/];
                    }
                });
            }); })).then();
        });
    };
    Registration.loop = function (optionsOrTick) {
        var _this = this;
        var tick;
        var waiter;
        if (typeof optionsOrTick === 'function') {
            tick = optionsOrTick;
            waiter = function () { return Promise.resolve(); };
        }
        else {
            tick = optionsOrTick.tick;
            waiter = optionsOrTick.waiter;
        }
        return Registration.create(function (_a) {
            var isDestroyed = _a.isDestroyed;
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!true) return [3 /*break*/, 3];
                            return [4 /*yield*/, waiter()];
                        case 1:
                            _b.sent();
                            if (isDestroyed()) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, tick()];
                        case 2:
                            _b.sent();
                            return [3 /*break*/, 0];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        });
    };
    /**
     * Create registration from a subscription
     *
     * @param subscriptionFactory - function that will create subscription
     * @returns registration that when destroyed will unsubscribe from the subscription
     */
    Registration.fromSubscription = function (subscriptionFactory) {
        var _this = this;
        return Registration.create(function () { return __awaiter(_this, void 0, void 0, function () {
            var subscriptions, newSubscription;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        subscriptions = [];
                        return [4 /*yield*/, subscriptionFactory(function (additionalSubscription) { return __awaiter(_this, void 0, void 0, function () { var _a, _b; return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        _b = (_a = subscriptions).push;
                                        return [4 /*yield*/, additionalSubscription];
                                    case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
                                }
                            }); }); })];
                    case 1:
                        newSubscription = _a.sent();
                        subscriptions.push(newSubscription);
                        // TODO: Do I for this need to import whole Subscription from RxJS
                        return [2 /*return*/, new Registration(function () {
                                for (var _i = 0, subscriptions_1 = subscriptions; _i < subscriptions_1.length; _i++) {
                                    var subscription = subscriptions_1[_i];
                                    subscription.unsubscribe();
                                }
                            })];
                }
            });
        }); });
    };
    /**
     * Creates a registration that is empty and has nothing to destroy
     * Note: This is useful for implementing null object pattern
     */
    Registration.void = function () {
        return new this(function () { });
    };
    /**
     *
     * TODO: Use in all places where manually setting up the listeners
     */
    Registration.createEventListener = function (_a) {
        var element = _a.element, type = _a.type, listener = _a.listener, options = _a.options;
        return Registration.create(function () {
            element.addEventListener(type, function (event) {
                listener(event);
            }, options);
            return function () {
                element.removeEventListener(type, listener, options /* TODO: Should I pass here options? */);
            };
        });
    };
    Registration.prototype.destroy = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.destroy.call(this)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, TeardownLogic_1.teardown(this.teardownLogic)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return Registration;
}(Destroyable_1.Destroyable));
exports.Registration = Registration;
/*

class ChildRegistration extends Registration {

}

const a:ChildRegistration = ChildRegistration.void();

*/
/**
 * TODO: Unite Registration and Destroyable
 * TODO: Maybe create some Registration.create helper for MobX observe/intercept
 */ 
//# sourceMappingURL=Registration.js.map